import { render, staticRenderFns } from "./MortgageApplicationUploadPopUp.vue?vue&type=template&id=5b20a602&scoped=true&"
import script from "./MortgageApplicationUploadPopUp.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationUploadPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationUploadPopUp.vue?vue&type=style&index=0&id=5b20a602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20a602",
  null
  
)

export default component.exports